import React, { useState, useEffect } from 'react';
import map from 'lodash/map';

const sizes = {
  sm: '1.05rem',
  md: '1.20rem',
  lg: '1.35rem',
};

const FontSizeOption = ({
  onClick = () => {},
}) => {
  const htmlTag = document.documentElement;
  const [size, setSize] = useState(
    localStorage.getItem('competition.font.size') || 'md',
  );

  useEffect(() => {
    htmlTag.style.fontSize = sizes[size];
    localStorage.setItem('competition.font.size', size);
  }, [size]);

  return (
    <span className="btn btn-sm btn-link">
      {map(sizes, (s, i) => (
        <span
          key={i}
          className="cursor-pointer ml-1"
          style={{ fontSize: s }}
          onClick={() => {
            setSize(i);
            onClick(i);
          }}
        >
          {i === size ? <u>A</u> : 'A'}
        </span>
      ))}
    </span>
  );
};

export default FontSizeOption;
